const FOCUSABLE_SELECTOR = 'button, [href], [tabindex]:not([tabindex="-1"])';
const MODAL_GA4_CLASS = "attrax-popup-modal--ga4";
const MODAL_HIDDEN_CLASS = "attrax-popup-modal--hidden";

let modalKeydownListener: ((e: KeyboardEvent) => void) | null = null;
let triggerElement: HTMLElement | null = null;

const handleTabTrap = (e: KeyboardEvent, modal: HTMLElement) => {
    const focusable = modal.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
        last.focus();
        e.preventDefault();
    } else if (!e.shiftKey && document.activeElement === last) {
        first.focus();
        e.preventDefault();
    }
};

const toggleModalVisibility = (modal: HTMLElement) => {
    modal.classList.toggle(MODAL_HIDDEN_CLASS);
    
    const isHidden = modal.classList.contains(MODAL_HIDDEN_CLASS);
    modal.setAttribute("aria-hidden", isHidden.toString());
    modal.tabIndex = isHidden ? -1 : 0;

    if (isHidden) {
        if (modalKeydownListener) {
            document.removeEventListener("keydown", modalKeydownListener);
            modalKeydownListener = null;
        }
        if (triggerElement) {
            triggerElement.focus();
            triggerElement = null;
        }
        return;
    }

    modalKeydownListener = (e: KeyboardEvent) => {
        if (e.key === "Escape") toggleModalVisibility(modal);
        if (e.key === "Tab") handleTabTrap(e, modal);
    };

    document.addEventListener("keydown", modalKeydownListener);

    setTimeout(() => {
        const firstFocusable = modal.querySelector<HTMLElement>(FOCUSABLE_SELECTOR);
        (firstFocusable || modal).focus();
    }, 50);
};

const setupTriggerListeners = () => {
    const triggers = document.querySelectorAll<HTMLElement>(".ga4-trigger");
    
    triggers.forEach((trigger) => {
        trigger.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            triggerElement = (trigger.querySelector('a') || trigger) as HTMLElement;
            
            const modal = document.querySelector<HTMLElement>(`.${MODAL_GA4_CLASS}`);
            if (modal) toggleModalVisibility(modal);
        });
    });
};

const createModalElement = (): HTMLElement => {
    const modal = document.createElement("div");
    modal.classList.add("attrax-popup-modal", MODAL_GA4_CLASS, MODAL_HIDDEN_CLASS);
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    modal.setAttribute("aria-hidden", "true");
    modal.tabIndex = -1;

    modal.innerHTML = `
        <div class="attrax-popup-modal__inner">
            <button class="attrax-popup-modal__close" aria-label="{{js.close.ga4.modal.aria-label}}">&times;</button>
            <p>{{js.ga4.information}}</p>
        </div>
    `;

    // Hook up the close button
    modal.querySelector(".attrax-popup-modal__close")
        ?.addEventListener("click", () => toggleModalVisibility(modal));

    return modal;
};

export const initializeGA4Modal = () => {
    const modal = createModalElement();
    document.body.appendChild(modal);
    setupTriggerListeners();
};